import { UpdateProject } from '../../../domain/projects/UpdateProject';
import { CreateProject } from '../../../domain/projects/createProject';
import { ProjectsAdapter } from '../../adapters/projects/projectsAdapters';
import { ProjectDTO } from '../../http/dtos/projects/projectDTO';
import { ProjectFilesListDTO } from '../../http/dtos/projects/projectFilesListDTO';
import { ProjectListDTO } from '../../http/dtos/projects/projectListDTO';
import { projectStatusDTO } from '../../http/dtos/projects/projectStatusDTO';
import httpClient from '../../http/httpClient';

export const ProjectsRepository = {
    GetProjectsList: () => {
        return httpClient
            .get('/projects/projects-list')
            .then((response: ProjectListDTO[]) =>
                ProjectsAdapter.getProjectsListAdapter(response)
            );
    },

    GetProject: (id: string) => {
        return httpClient
            .get('/projects/project-by-id/' + id)
            .then((response: ProjectDTO) =>
                ProjectsAdapter.getProjectAdapter(response)
            );
    },

    CreateProject: (newEmployee: CreateProject) => {
        return httpClient
            .post('/projects', newEmployee)
            .then((response) => response);
    },

    UpdateProject: (newEmployee: UpdateProject, id: number) => {
        return httpClient
            .put('/projects/update-project/' + id, newEmployee)
            .then((response) => response);
    },

    GetProjectStatusList: () => {
        return httpClient
            .get('/project-status/project-status-list')
            .then((response: projectStatusDTO[]) => response);
    },

    UploadProjectFile: (projectId: string | undefined, formData: FormData) => {
        return httpClient
            .post('/projects/' + projectId + '/files', formData)
            .then((response) => response);
    },

    GetProjectsFilesList: (projectId: string) => {
        return httpClient
            .get('/projects/' + projectId + '/files-list')
            .then((response: ProjectFilesListDTO[]) =>
                ProjectsAdapter.getProjectFilesList(response)
            );
    },
};
